import { callGetApi } from './apiCallerProxy';

const intercomPrefix = accountId => `/${accountId}/intercom`;

const intercomApi = {
    getIntercomParameters: accountId => callGetApi(`${intercomPrefix(accountId)}`),
};

export default intercomApi;
